import { Component, OnInit,Input, OnDestroy, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { ScreeningAdditionalData, TriggerRecordTogglePayload, ScreeningLight } from 'src/app/models/screeningInvite';
import { Subscription, Subject } from 'rxjs';
import { VendorResponseTypes, SearchRecord, SearchPackage, CriminalSearchTypes } from 'src/app/packages-module/models/searchPackage';
import { take, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CriminalRecord } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { CriminalService } from 'src/app/decision-grid/Services/criminal.service';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchAddDialogComponent } from 'src/app/packages-module/components/search-add-dialog/search-add-dialog.component';
import { ClientPackagePricing } from 'src/app/packages-module/models/clientPackagePrice';
import { ScreeningService } from '../../services/screening.service';
import { SearchPackageService } from 'src/app/services/search-package.service';

@Component({
  selector: 'app-criminal-records-manager',
  templateUrl: './criminal-records-manager.component.html',
  styleUrls: ['./criminal-records-manager.component.less']
})
export class CriminalRecordsManagerComponent implements OnInit,OnDestroy {
  @Input() pkg : ScreeningAdditionalData;
  @Input() viewMode : number = 0; // 1 means single record
  @Input() clientPricingModel : ClientPackagePricing;
  @Input() appliedPackage : SearchPackage;
  loading : boolean = true;
  $rcrdsLoaded : Subscription;
  modalRef : NgbModalRef;
  // modalService: NgbModal;
  lastKey : any = {
    key : 'excludeFromReport',
    ascending : false
  };
  constructor(public appData: ApplicantDataService, public toast : ToastrService, public crim : CriminalService, public modalService : NgbModal, public screenings: ScreeningService, public srchs : SearchPackageService){

  }
  ngOnDestroy(): void {
    this.$rcrdsLoaded.unsubscribe();
  }
  ngOnInit(): void {
    this.$rcrdsLoaded = this.appData.$crimRecordsLoaded.subscribe(()=>{ 
      this.appData.sortByKey(this.appData._criminalRecords,this.lastKey.key,this.lastKey.ascending);
      this.loading = false;
      setTimeout(() => {
        if(!this.loading && this.crim.selectedCrimRecord){
          let pkd = document.getElementsByClassName('picked')[0];
          let indx = Number(pkd.getAttribute('index'));
          if(indx >=5){
             indx = indx-2;
            document.querySelector(`div.criminal-history tr[index="${indx}"]`).scrollIntoView({behavior : 'smooth'});
          }
        }
      }, 750);
    });
    if(this.viewMode == 0)
      this.appData.GetCriminalRecordsForApplicant(this.pkg.searchEntryId);
    else{
      this.appData._criminalRecords = [this.crim.selectedCrimRecord];
      this.loading = false;
    }
  }

  toggleRecordStatus(include : boolean, record : CriminalRecord){
    let pld = new TriggerRecordTogglePayload();
    pld.recordIds = [record.offenseId];
    pld.recordsIncluded = include;
    pld.searchEntryId = this.pkg.searchEntryId;
    pld.searchType = VendorResponseTypes.Criminal;
    
    this.appData.ToggleRecord2([pld]).pipe(take(1), tap(_=>{
     console.info(_);
    })).subscribe(()=>{
      this.toast.success(`Record Toggle Success`);
      record.excludeFromReport = !include
    },
    ()=>{this.toast.error(`Record Toggle Failed`);});
  }

 
  selectRecord(rco : CriminalRecord, index : number){
    rco.index = index;
    this.crim.selectedCrimRecord = rco;
    // if(this.crim.selectedCrimRecord.find(scr =>{ return scr.offenseId == rco.offenseId})){
    //   let ind = this.crim.selectedCrimRecord.indexOf(rco);
    //   this.crim.selectedCrimRecord.splice(ind,1);
    //   rco.index = undefined;
    // }else
    //    this.crim.selectedCrimRecord.push(rco);  
  
  }


  sort(key : string){
    if(this.lastKey.key == key){
      this.lastKey.ascending = !this.lastKey.ascending;
    }else{
      this.lastKey.key = key;
      this.lastKey.ascending = false;
    }
    this.appData.sortByKey(this.appData._criminalRecords,this.lastKey.key,this.lastKey.ascending)
  }

  orderCounty(rco : CriminalRecord, statsrch : boolean = false){
    let canAdd : boolean = true;
    if(this.screeningToEdit.additionalData.filter(sad => {
       let hasSrch =  JSON.parse(sad.searchMetaJSON).searchDepth == (statsrch ? CriminalSearchTypes.SingleState : CriminalSearchTypes.County); 
       return hasSrch;
    }).length > 0)
    {
      console.log('THIS FUKR ALREADY GOT A SEARCH LIKE THAT')
      this.screeningToEdit.additionalData.filter(sad => {return JSON.parse(sad.searchMetaJSON).searchDepth == (statsrch ? CriminalSearchTypes.SingleState : CriminalSearchTypes.County); }).forEach(srch => {
        let mta = JSON.parse(srch.searchMetaJSON)
        if(mta.state == rco.state && statsrch) {
          this.toast.error(`Record already has a statewide search for ${rco.state}`);
          canAdd = false;
        }
        else if(mta.state == rco.state && !statsrch && mta.county == rco.duplicateJurisdictionToCheck)
        {
          this.toast.error(`Record already has a county search for ${rco.duplicateJurisdictionToCheck}-${rco.state}`);
          canAdd= false;
        } 
      
      })
    }
    if(canAdd)
    {
      this.modalRef = this.modalService.open(SearchAddDialogComponent, { centered: true, size: 'lg' })
      this.modalRef.componentInstance.name = 'SearchAddDialogComponent';
      let searchToAdd = new SearchRecord();
      searchToAdd.searchType = VendorResponseTypes.Criminal;
      this.modalRef.componentInstance.searchAdded.subscribe((scc: SearchRecord) => this.searchAdded2(scc));
      this.modalRef.componentInstance.search = searchToAdd;
      this.modalRef.componentInstance.existingPackage = this.appliedPackage;
      this.modalRef.componentInstance.clientPackageOverrides = this.clientPricingModel;
      this.modalRef.componentInstance.packageEditMode = false;
      this.modalRef.componentInstance.additionalData = this.pkg;
      this.modalRef.componentInstance.autoPopulateRecord = rco;
      if(statsrch) this.modalRef.componentInstance.isStateAutoMode = true;
      else this.modalRef.componentInstance.iscountyAutoMode = true;
    }
   
    // console.log(rco);
  }

  searchAdded(){
    this.screenings.FetchScreeningAdditionalData(this.screenings.screenings[0].id).pipe(take(1),tap((scc: ScreeningAdditionalData[]) => {
      this.screenings.screenings[0].additionalData = scc.map(s => {
        return Object.assign(new ScreeningAdditionalData(), s);
      });
    })).subscribe();
  }

  
  public get screeningToEdit() : ScreeningLight {
    return this.screenings.screenings[0];
  }
  

  searchAdded2(event : SearchRecord){
    this.srchs.addSearchToReport(this.screeningToEdit.id, event.id).subscribe(result => {
      this.toast.success('search added to report');
      this.toast.warning()

      this.screenings.FetchScreeningAdditionalData(this.screeningToEdit.id).subscribe((rep:ScreeningAdditionalData[])=>{
        this.screeningToEdit.additionalData = [];
        rep.forEach(element => {
          this.screeningToEdit.additionalData.push(Object.assign(new ScreeningAdditionalData(),element))
        });
      },(err:any)=>{
        this.toast.warning('There was an error reloading your search results list.Please refresh the page to get your new search.','Error Refreshing Searches')
      })     
    },
    (error) => {
      //the search failed to save...
      this.toast.error('Search failed to add to report!', '', { closeButton: true, disableTimeOut: true });
    });  
  }

}
